export default "/images/logout.png?a0d26807064ca6338e5631d6a0cc3ef0";